'use strict';
angular.module('appQuickSignServiceModule', ['appNewAssociationModule', 'appNewPushModule', 'quickSignReasonOfReturnModule', 'appQuickSignMoveToModule', 'appQuickSignTimingSignModule', 'appQuickSignListMapDetailModule', 'appQuickSignEditPushDetailModule', 'appNewQuickSignTypeModule', 'newRelationModule']).factory('appQuickSignService', ['$q', '$modal', 'trsHttpService', 'trsspliceString', 'modalDialog', 'messagePublishService',
    function($q, $modal, trsHttpService, trsspliceString, modalDialog, messagePublishService) {
        return {

            /**
             * [newAssociation description]一键快签--我的稿件:新建关联弹窗服务
             * @param  {[str]} modalTitle [description]标题
             * @param  {[num]} siteid     [description]站点ID
             * @param  {[num]} reltype  [description]关联类型
             * @param  {[num]} platform   [description]平台种类
             * @param  {[fun]} success    [description]回调函数
             * @return {[type]}            [description]
             */
            newAssociation: function(modalTitle, siteid, reltype, platform, success) {
                var modalInstance = $modal.open({
                    templateUrl: './editingCenter/app/quickSign/service/newAssociation/newAssociation_tpl.html',
                    windowClass: 'app-new-association-window',
                    backdrop: false,
                    controller: 'appNewAssociationCtrl',
                    resolve: {
                        params: function() {
                            return {
                                'siteid': siteid,
                                'reltype': reltype,
                                'modalTitle': modalTitle,
                                'platform': platform,
                            };
                        },
                    },
                });
                modalInstance.result.then(function(result) {
                    success(result);
                });
            },

            /**
             * [newPush description]一键快签--我的推送:新建推送弹窗服务
             * @param  {[str]} modalTitle [description]标题
             * @param  {[num]} siteid     [description]站点ID
             * @param  {[num]} reltype  [description]关联类型
             * @param  {[num]} platform   [description]平台种类
             * @param  {[fun]} success    [description]回调函数
             * @return {[type]}            [description]
             */
            newPush: function(modalTitle, siteid, reltype, platform, success) {
                var modalInstance = $modal.open({
                    templateUrl: './editingCenter/app/quickSign/service/newPush/newPush_tpl.html',
                    windowClass: 'app-new-push-window',
                    backdrop: false,
                    controller: 'appNewPushCtrl',
                    resolve: {
                        params: function() {
                            return {
                                'siteid': siteid,
                                'reltype': reltype,
                                'modalTitle': modalTitle,
                                'platform': platform,
                            };
                        },
                    },
                });
                modalInstance.result.then(function(result) {
                    success(result);
                });
            },
            // 关联管理 - 退回原因
            reasonOfReturn: function(obj) {
                var modalInstance = $modal.open({
                    templateUrl: './editingCenter/app/quickSign/service/reasonOfReturn/reasonOfReturn_tpl.html',
                    windowClass: 'app-quickReasonOfReturn-window',
                    backdrop: false,
                    controller: 'quickSignReasonOfReturnCtrl',
                    resolve: {
                        obj: function() {
                            return obj;
                        },
                    },
                });
                modalInstance.result.then(function(result) {
                    success(result);
                });
            },

            /**
             * [moveTo description]一键快签--关联管理:转移至弹窗服务
             * @param  {[str]} objData [description]所需参数
             * @param  {[fun]} success    [description]回调函数
             * @return {[type]}            [description]
             */
            moveTo: function(objData, success) {
                var modalInstance = $modal.open({
                    templateUrl: './editingCenter/app/quickSign/service/moveTo/moveTo_tpl.html',
                    windowClass: 'app-quickSignMoveTo-window',
                    backdrop: false,
                    controller: 'appQuickSignMoveToCtrl',
                    resolve: {
                        objData: function() {
                            return objData;
                        },
                    },
                });
                modalInstance.result.then(function(result) {
                    success(result);
                });
            },
            // 一键快签 - 定时快签
            timingSign: function(arr) {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: './editingCenter/app/quickSign/service/timingSign/timingSign_tpl.html',
                    windowClass: 'app-quickSignTimingSign-window',
                    backdrop: false,
                    controller: 'appQuickSignTimingSignCtrl',
                    resolve: {
                        obj: function() {
                            return arr;
                        },
                    },
                });
                modalInstance.result.then(function(result) {
                    defer.resolve(result);
                }, function() {
                    defer.reject('cancel');
                });
                return defer.promise;
            },
            // 一键快签 - 列表图(稿件详情)弹窗
            listMapDetail: function(obj, success) {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: './editingCenter/app/quickSign/service/listMapDetail/listMapDetail_tpl.html',
                    windowClass: 'app-quickSignListMapDetail-window',
                    backdrop: false,
                    controller: 'appQuickSignListMapDetailCtrl',
                    // size: 'lg',
                    resolve: {
                        obj: function() {
                            return obj;
                        },
                        // itemInfo: function() {
                        //     return itemInfo;
                        // },
                        // selectedArray: function() {
                        //     return selectedArray;
                        // },
                    },
                });
                modalInstance.result.then(function (result) {
                    success(result);
                    defer.resolve('commit');
                }, function() {
                    defer.reject('cancel');
                });
                return defer.promise;
            },
            
            /**
             * [fetchFromBigData description]取稿操作
             *
             * @param   {[type]}  obj            [obj description]
             * @param   {[type]}  selectedArray  [selectedArray description]
             * @param   {[type]}  list           [list description]
             *
             * @return  {[type]}                 [return description]
             */
            fetchFromBigData: function (obj, selectedArray, list) {
                var selectArr = angular.isArray(selectedArray) ? selectedArray : [selectedArray];
                var defer = $q.defer();
                var params = {
                    serviceid: 'mlf_appquicksign',
                    methodname: 'fetch',
                    Guid: trsspliceString.spliceString(selectArr, 'ZB_GUID', ','),
                    indexName: obj.indexName,
                    channelName: 'iwo',
                    // SourceName: trsspliceString.spliceString(selecrArr, 'ZB_SOURCE_SITE', ','),
                    MlfApp: obj.channelid,
                    IsTiming: obj.IsTiming,
                };
                if (list) {
                    params.ListStyle = list.LISTSTYLE;
                    params.ListTitle = list.TITLE;
                    params.ListPics = list.LISTPICS;
                    params.IsFocusImage = list.IsFocusImage;
                    params.FocusImageTitle = list.FocusImgTitle;
                    params.FocusImageDesc = list.FocusImageDesc;
                    params.FocusImage = list.FOCUSIMAGE;
                }
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'POST').then(function (data) {
                    defer.resolve(data);
                },
                function (data) {
                    defer.reject(data);
                });
                return defer.promise;
            },
            // 一键快签操作
            oneKeyQuickSign: function(data) {
                var defer = $q.defer();
                var params = {
                    serviceid: 'mlf_appquicksign',
                    methodname: 'quickSignDoc',
                    ChnlDocIds: trsspliceString.spliceString(data.REPORTS, 'CHNLDOCID', ','),
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    modalDialog.alertType('快签成功', '', 'success', false);
                    defer.resolve(data);
                });
                return defer.promise;
            },
            // 一键快签 - 编辑推送详情弹窗
            editPushDetail: function(obj, itemInfo, selectedArray) {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: './editingCenter/app/quickSign/service/editPushDetail/editPushDetail_tpl.html',
                    windowClass: 'app-quickSignEditPushDetail-window',
                    backdrop: false,
                    controller: 'appQuickSignEditPushDetailCtrl',
                    resolve: {
                        obj: function() {
                            return obj;
                        },
                        itemInfo: function() {
                            return itemInfo;
                        },
                        selectedArray: function() {
                            return selectedArray;
                        },
                    },
                });
                modalInstance.result.then(function(result) {
                    defer.resolve('commit');
                }, function() {
                    defer.reject('cancel');
                });
                return defer.promise;
            },

            /**
             * [newQuickSignType description]一键快签--签发类型:新建弹窗服务
             * @param  {[str]} modalTitle [description]标题
             * @param  {[num]} siteid     [description]站点ID
             * @param  {[fun]} success    [description]回调函数
             * @return {[type]}            [description]
             */
            newQuickSignType: function(modalTitle, siteid, success) {
                var modalInstance = $modal.open({
                    templateUrl: './editingCenter/app/quickSign/service/newQuickSignType/newQuickSignType_tpl.html',
                    windowClass: 'app-newQuickSignType-window',
                    backdrop: false,
                    controller: 'appNewQuickSignTypeCtrl',
                    resolve: {
                        obj: function() {
                            return {
                                'siteid': siteid,
                                'modalTitle': modalTitle,
                            };
                        },
                    },
                });
                modalInstance.result.then(function(result) {
                    success(result);
                });
            },

            /**
             * [excludeRepeatFromArr description]
             *
             * @param   {[type]}  arr  [arr description]
             *
             * @return  {[type]}       [return description]
             */
            excludeRepeatFromArr: function(arr) {
                // let arr = [1, 2, 3, 4, 5, 6, 6, 6]; //需要被排重的数组
                let newArr = {}; // 临时对象
                arr = arr.filter((item) => {
                    if (newArr[item]) {
                        return false;
                    } else {
                        newArr[item] = true;
                        return true;
                    }
                });
                return arr;
            },
            openNewRelation: function(modalTitle, item, success) {
                var modalInstance = $modal.open({
                    templateUrl: './editingCenter/app/quickSign/service/newRelation/newRelation.html',
                    windowClass: 'newRelation-window',
                    backdrop: false,
                    controller: 'newRelationCtrl',
                    resolve: {
                        params: function() {
                            return {
                                'modalTitle': modalTitle,
                                'item': item,
                            };
                        },
                    },
                });
                modalInstance.result.then(function(result) {
                    success(result);
                });
            },

        };
    },
]);
